import dynamic from 'next/dynamic';
import { MapProps } from 'types/map';

export const LazyGoogleMap = dynamic<MapProps>(
    () => import('components/Basic/Map/GoogleMap/GoogleMap').then(({ GoogleMap }) => GoogleMap),
    { ssr: false },
);

export const LazyPigeonMap = dynamic<MapProps>(
    () => import('components/Basic/Map/PigeonMap/PigeonMap').then(({ PigeonMap }) => PigeonMap),
    { ssr: false },
);

export const LazySeznamMap = dynamic<MapProps>(
    () => import('components/Basic/Map/SeznamMap/SeznamMap').then(({ SeznamMap }) => SeznamMap),
    { ssr: false },
);
